module.exports = __webpack_public_path__ + "static/media/acero-inoxidable-ornamental-redonda.8f58b52c.jpg";